import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { Page } from '@/shared/models/page.model';
import { MedicoEstatisticaAgrupadaResponse } from '@/core/api/sicom-api/registro/medico/controle-administrativo/medico-estatistica-agrupada.model';

export interface CctDetalheResponse {
    ufSgUf: string | null;
    identificador: string | null;
    descricao: string | null;
    situacao: string | null;
    complemento: string | null;
}

@Injectable({ providedIn: 'root' })
export class CctService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    readonly PATH = '/api/v1/gestao/cct';

    consultarComissoesPorTipo(uf?: string, limite?: number, context?: HttpContext): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.http.get<MedicoEstatisticaAgrupadaResponse[]>(`${this.PATH}/consulta/comissoes-tipo`, this.criarOpcoes(uf, context, { limite }));
    }

    consultarComissoesPorSituacao(uf?: string, context?: HttpContext): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.http.get<MedicoEstatisticaAgrupadaResponse[]>(`${this.PATH}/consulta/comissoes-situacao`, this.criarOpcoes(uf, context));
    }

    consultarComissoesPorUf(uf?: string, limite?: number, context?: HttpContext): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.http.get<MedicoEstatisticaAgrupadaResponse[]>(`${this.PATH}/consulta/comissoes-uf`, this.criarOpcoes(uf, context, { limite }));
    }

    consultarReunioesPorMes(uf?: string, ano?: number, context?: HttpContext): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.http.get<MedicoEstatisticaAgrupadaResponse[]>(`${this.PATH}/consulta/reunioes-mes`, this.criarOpcoes(uf, context, { ano }));
    }

    consultarReunioesPorModalidade(uf?: string, ano?: number, context?: HttpContext): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.http.get<MedicoEstatisticaAgrupadaResponse[]>(`${this.PATH}/consulta/reunioes-modalidade`, this.criarOpcoes(uf, context, { ano }));
    }

    consultarReunioesPorStatus(uf?: string, ano?: number, limite?: number, context?: HttpContext): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.http.get<MedicoEstatisticaAgrupadaResponse[]>(`${this.PATH}/consulta/reunioes-status`, this.criarOpcoes(uf, context, { ano, limite }));
    }

    consultarTarefasPorSituacao(uf?: string, context?: HttpContext): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.http.get<MedicoEstatisticaAgrupadaResponse[]>(`${this.PATH}/consulta/tarefas-situacao`, this.criarOpcoes(uf, context));
    }

    consultarDetalhe(cardId: string, uf?: string | null, ano?: number, page?: number, size?: number, codigo?: string | null, context?: HttpContext): Observable<Page<CctDetalheResponse>> {
        return this.http.get<Page<CctDetalheResponse>>(`${this.PATH}/consulta/detalhe/${cardId}`, this.criarOpcoes(uf ?? undefined, context, { ano, page, size, codigo }));
    }

    private criarOpcoes(uf?: string, context?: HttpContext, parametrosExtras: Record<string, string | number | null | undefined> = {}): { params?: HttpParams; context?: HttpContext } {
        let params = new HttpParams();

        if (uf) {
            params = params.set('uf', uf);
        }

        Object.entries(parametrosExtras).forEach(([chave, valor]) => {
            if (valor !== null && valor !== undefined && valor !== '') {
                params = params.set(chave, String(valor));
            }
        });

        if (!params.keys().length) {
            return { context };
        }

        return { params, context };
    }
}
